import { format } from "date-fns"

export const infoFormatter = (fields,info) => {
    return fields.map((key)=>({
                                'key':key,
                                'value':info?.[key]||null
                            }))
}

// export const formatDate = (date, type) => {
//   const d = new Date(date);
//   const isoString = d.toISOString().split('T')[0]; // "2025-08-06"

//   if (type === 'string') {
//     return isoString;
//   } else {
//     return d;
//   }
// }

export const formatDate = (date, type) => {
  const d = new Date(date);
  const taiwanOffsetMs = 8 * 60 * 60 * 1000; // UTC+8

  // 取得加上時區補正的年月日
  const taiwanTime = new Date(d.getTime() + taiwanOffsetMs);
  const yyyy = taiwanTime.getUTCFullYear();
  const mm = String(taiwanTime.getUTCMonth() + 1).padStart(2, '0');
  const dd = String(taiwanTime.getUTCDate()).padStart(2, '0');
  const isoDate = `${yyyy}-${mm}-${dd}`;

  if (type === 'string') {
    return isoDate; // ✅ 正確格式 + 正確台灣日期
  } else {
    return d;
  }
}


// export const formatDate = (date,type) => {
//     // const theDate = new Date(new Date(date).toLocaleDateString('en-US',{timeZone:'Asia/Taipei'}))
//     const dateString = new Date(date)
//                         .toLocaleDateString(
//                             'zh-TW',
//                             {
//                                 year:'numeric',
//                                 month:'2-digit',
//                                 day:'2-digit',
//                                 timeZone:'Asia/Taipei'
//                             }
//                         )
//                         .replace(/\//g,'-')
//     // const dateString = format(theDate,'yyyy-MM-dd')
//     if(type==='string'){
//         return dateString
//     }else{
//         // return theDate
//         return new Date(date)
//     }
// }

export const formatCurrencyText = (number) => {
    
    return typeof number === 'number'
            ? number.toString().replace(/\B(?=(\d{3})+(?!\d))/,',')
            : number
}